var _defs, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M21.005 22.412v6.586a1 1 0 0 1-2 0v-6.586l-2.292 2.293a1 1 0 0 1-1.415-1.414l4-4a1 1 0 0 1 1.415 0l4 4a1 1 0 0 1-1.415 1.414l-2.293-2.293zm-2.984-12.354a9 9 0 0 1 7.464 5.94h.521a6 6 0 0 1 2.868 11.268 1 1 0 0 1-.957-1.756 4 4 0 0 0-1.912-7.512h-1.26a1 1 0 0 1-.968-.75 7 7 0 1 0-12.022 6.388 1 1 0 1 1-1.499 1.324 9 9 0 0 1 7.765-14.902z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#A3A3A3",
    fillRule: "nonzero",
    transform: "translate(-8 -10)",
    xlinkHref: "#a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.15c2bd9b7ff34194ec08f43d34d6767c.svg";
export { ForwardRef as ReactComponent };